import React from 'react'
import { Form, Input, Button } from 'antd'
import { func } from 'prop-types'

import { useCreateManufacturer } from '@graphql/mutations'

function ManageManufacturerForm({ afterSubmit }) {
  const [form] = Form.useForm()
  const [createManufacturer, { loading }] = useCreateManufacturer()

  const onFinish = data => {
    createManufacturer({
      variables: {
        data: { ...data },
      },
      refetchQueries: ['GetManufacturersQuery'],
    }).then(callback => afterSubmit(callback), form.resetFields())
  }

  return (
    <Form onFinish={onFinish} form={form}>
      <Form.Item
        name="name"
        rules={[
          {
            required: true,
            message: `Campo obrigatório`,
          },
        ]}
        hasFeedback
      >
        <Input placeholder="Nome do fabricante" size="large" autoFocus />
      </Form.Item>

      <Button
        type="primary"
        htmlType="submit"
        size="large"
        disabled={loading}
        block
      >
        Criar fabricante
      </Button>
    </Form>
  )
}

ManageManufacturerForm.propTypes = {
  afterSubmit: func,
}

ManageManufacturerForm.defaultProps = {
  afterSubmit: null,
}

export default ManageManufacturerForm
